import { render } from "./sendEmail.vue?vue&type=template&id=5cc5b4b7"
import script from "./sendEmail.vue?vue&type=script&lang=js"
export * from "./sendEmail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/users/profile/actions/sendEmail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5cc5b4b7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5cc5b4b7', __exports__)) {
    console.log('reload')
    api.reload('5cc5b4b7', __exports__)
  }
  
  module.hot.accept("./sendEmail.vue?vue&type=template&id=5cc5b4b7", () => {
    console.log('re-render')
    api.rerender('5cc5b4b7', render)
  })

}


export default __exports__